/**
 * single source of truth for the variable interpolation regex.
 * matches: {{varName}}, {{$dynamicVar}}, {{$dynamicVar arg1 arg2}}
 */
export const VARIABLE_REGEX = /\{\{\s*([^{}\s]+)(?:\s+([^{}]*?))?\s*\}\}/g;
